import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("入室中の生徒に一斉メッセージ送信")
const _hoisted_2 = { class: "w-3/4 mx-auto mb-6" }
const _hoisted_3 = { class: "w-3/4 mx-auto mb-6" }
const _hoisted_4 = { class: "w-full" }
const _hoisted_5 = /*#__PURE__*/_createVNode("p", { class: "mb-1 font-medium text-sm text-gray-500" }, " メッセージと共に送信する画像（任意） ", -1)
const _hoisted_6 = { class: "w-full flex items-center overflow-x-scroll" }
const _hoisted_7 = /*#__PURE__*/_createVNode("path", { d: "M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" }, null, -1)
const _hoisted_8 = { for: "image" }
const _hoisted_9 = /*#__PURE__*/_createVNode("span", null, "画像を追加", -1)
const _hoisted_10 = { class: "mr-6 text-gray-500 font-medium text-sm" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" 一斉送信 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_m_text_area = _resolveComponent("m-text-area")
  const _component_m_icon = _resolveComponent("m-icon")
  const _component_m_button = _resolveComponent("m-button")
  const _component_m_base_modal = _resolveComponent("m-base-modal")

  return (_openBlock(), _createBlock(_component_m_base_modal, { onClose: _ctx.close }, {
    title: _withCtx(() => [
      _hoisted_1
    ]),
    body: _withCtx(() => [
      _createVNode("div", _hoisted_2, [
        _createVNode(_component_m_text_area, {
          label: "メッセージ内容",
          name: "message",
          placeholder: "メッセージを入力",
          value: _ctx.message,
          onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.message = $event))
        }, null, 8, ["value"])
      ]),
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _hoisted_5,
          _createVNode("div", _hoisted_6, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.fileUrls, (url, i) => {
              return (_openBlock(), _createBlock("div", {
                key: url,
                class: "relative w-20 h-20 mr-2"
              }, [
                _createVNode("img", {
                  src: url,
                  alt: "Upload Image",
                  class: "w-16 h-16 mx-2 my-2 object-cover rounded-md border-2 border-gray-200"
                }, null, 8, ["src"]),
                (_openBlock(), _createBlock("svg", {
                  xmlns: "http://www.w3.org/2000/svg",
                  viewBox: "0 0 20 20",
                  "fill-rule": "evenodd",
                  "clip-rule": "evenodd",
                  fill: "currentColor",
                  class: "absolute right-0 top-0 w-5 h-5 text-gray-500 transition-colors duration-300 cursor-pointer hover:text-black",
                  onClick: ($event: any) => (_ctx.removeImage(i))
                }, [
                  _hoisted_7
                ], 8, ["onClick"]))
              ]))
            }), 128)),
            _createVNode("label", _hoisted_8, [
              _createVNode(_component_m_button, {
                color: "primary-500",
                "hover-color": "primary-600",
                outline: "",
                "is-div": ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_m_icon, { type: "plus" }),
                  _hoisted_9
                ]),
                _: 1
              }),
              _createVNode("input", {
                id: "image",
                type: "file",
                accept: "image/*",
                name: "image",
                multiple: "",
                class: "hidden",
                onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.imageUpload && _ctx.imageUpload(...args)))
              }, null, 32)
            ])
          ])
        ])
      ])
    ]),
    footer: _withCtx(() => [
      _createVNode("p", _hoisted_10, " 対象生徒: " + _toDisplayString(_ctx.filteredStudents.length) + "人 ", 1),
      _createVNode(_component_m_button, {
        color: "primary-500",
        "hover-color": "primary-600",
        disabled: !_ctx.validData,
        onClick: _ctx.sendMessage
      }, {
        default: _withCtx(() => [
          _hoisted_11
        ]),
        _: 1
      }, 8, ["disabled", "onClick"])
    ]),
    _: 1
  }, 8, ["onClose"]))
}